import { Dropdown } from 'bootstrap';
function load_sidebar() {
    const none = 'd-none';
    const block = 'd-block';
    const sidebar = document.getElementById('sidebar');
    const sidebarSm = document.getElementById('sidebarSm');
    const body = document.body;
    const collapseContainer = document.getElementById('collapseSidebar');
    const button = document.getElementById('collapseSidebarButton'); // The sidebar collapse button
    const setCookie = (name, value, days)=>{
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
    };
    const toggleSidebar = ()=>{
        if (!sidebar || !sidebarSm || !body) return;
        const isSidebarHidden = sidebar.classList.contains(none);
        sidebarSm.classList.toggle(none, isSidebarHidden);
        sidebar.classList.toggle(none, !isSidebarHidden);
        body.classList.toggle('sidebar-sm', !isSidebarHidden);
        body.classList.toggle('sidebar-full', isSidebarHidden);
        button.innerHTML = isSidebarHidden ? '<i class="fe fe-chevron-left"></i>' : '<i class="fe fe-chevron-right"></i>';
        setCookie('use_small_sidebar', isSidebarHidden ? 'false' : 'true', 7);
    };
    const initializeCollapseSidebarButton = ()=>{
        if (button) {
            button.addEventListener('click', toggleSidebar);
            collapseContainer.addEventListener('mouseenter', ()=>{
                button.classList.add('show-collapse-button');
            });
            collapseContainer.addEventListener('mouseleave', ()=>{
                button.classList.remove('show-collapse-button');
            });
            sidebar.addEventListener('mouseenter', ()=>{
                button.classList.add('show-collapse-button');
            });
            sidebar.addEventListener('mouseleave', ()=>{
                button.classList.remove('show-collapse-button');
            });
            sidebarSm.addEventListener('mouseenter', ()=>{
                button.classList.add('show-collapse-button');
            });
            sidebarSm.addEventListener('mouseleave', ()=>{
                button.classList.remove('show-collapse-button');
            });
        }
    };
    const handleViewportChange = (e)=>{
        const isWideViewport = e.matches;
        const isSidebarSm = body.classList.contains('sidebar-sm');
        if (!sidebar || !sidebarSm) return;
        if (isWideViewport) {
            sidebar.classList.toggle(none, isSidebarSm);
            sidebarSm.classList.toggle(none, !isSidebarSm);
        } else {
            sidebarSm.classList.add(none);
            sidebar.classList.remove(none);
            sidebar.classList.add(block);
        }
    };
    // Bootstrap disables Popper for any dropdown inside a `.navbar`, and this sidebar is one - so these
    // flyouts are positioned entirely by CSS, and Popper's own overflow handling never runs. CSS alone
    // can't solve it either: the menu is anchored to its nav item, so how much room is left underneath
    // depends on where that item sits, which no stylesheet can see. So measure it once the menu is open.
    const VIEWPORT_PADDING = 16;
    const fitMenuToViewport = (menu)=>{
        if (!menu) return;
        // Clear any previous fit so we measure the menu's natural size, not the last one we constrained
        menu.style.marginTop = '';
        menu.style.maxHeight = '';
        const { top, height } = menu.getBoundingClientRect();
        const available = window.innerHeight - top - VIEWPORT_PADDING;
        if (height <= available) return; // already fits - leave it where CSS put it
        // Slide the bottom up by as much as there is room for above, never past the top of the window,
        // then cap the height to whatever space that leaves so the overflow scrolls instead of vanishing.
        const shift = Math.min(height - available, Math.max(top - VIEWPORT_PADDING, 0));
        if (shift > 0) menu.style.marginTop = `${-shift}px`;
        menu.style.maxHeight = `${available + shift}px`;
    };
    // Bootstrap's own auto-close only looks for [data-bs-toggle="dropdown"] (its SELECTOR_DATA_TOGGLE),
    // and these use a custom "navdropdown" value, so clearMenus never finds them - open a second panel
    // and the first stays up behind it. Track them so opening one can close the rest.
    const navDropdowns = Array.from(document.querySelectorAll('[data-bs-toggle="navdropdown"]')).map((toggle)=>({
            toggle,
            menu: toggle.nextElementSibling,
            instance: new Dropdown(toggle)
        }));
    navDropdowns.forEach(({ toggle, menu, instance })=>{
        // Toggle the dropdown when the button is clicked
        toggle.addEventListener('click', (e)=>{
            e.preventDefault();
            navDropdowns.forEach((other)=>{
                if (other.toggle !== toggle) other.instance.hide();
            });
            instance.toggle();
        });
        toggle.addEventListener('shown.bs.dropdown', ()=>fitMenuToViewport(menu));
    });
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    mediaQuery.addEventListener('change', handleViewportChange);
    handleViewportChange(mediaQuery);
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeCollapseSidebarButton);
    } else {
        initializeCollapseSidebarButton();
    }
}
// Bootstrap's clearMenus dismisses an open dropdown when you click away, but only for toggles matching
// [data-bs-toggle="dropdown"] - so it never dismisses these. Registered here rather than inside
// load_sidebar because `document` survives Turbolinks navigations, and load_sidebar runs again on each
// one; a listener added in there would stack up. Querying on each click keeps it correct for whatever
// sidebar is currently rendered. Clicks inside the menu are ignored so scrolling a long list, or
// dragging its scrollbar, doesn't dismiss it.
document.addEventListener('click', (event)=>{
    document.querySelectorAll('[data-bs-toggle="navdropdown"].show').forEach((toggle)=>{
        const menu = toggle.nextElementSibling;
        if (toggle.contains(event.target) || menu && menu.contains(event.target)) return;
        const instance = Dropdown.getInstance(toggle);
        if (instance) instance.hide();
    });
});
window.addEventListener('ready', load_sidebar);
window.addEventListener('turbolinks:load', load_sidebar);
